
// constants images for search

export const images = [
    {
        "id": 10194,
        "name": "Toy Story Collection",
        "poster_path": "https://image.tmdb.org/t/p/original/7G9915LfUQ2lVfwMEEhDsn3kT4B.jpg"
    },
    {
        "id": 119050,
        "name": "Grumpy Old Men Collection",
        "poster_path": "https://image.tmdb.org/t/p/original/nLvUdqgPgm3F85NMCii9gVFUcet.jpg"
    },
    {
        "id": 96871,
        "name": "Father of the Bride Collection",
        "poster_path": "https://image.tmdb.org/t/p/original/nts4iOmNnq7GNicycMJ9pSAn204.jpg"
    },
    {
        "id": 645,
        "name": "James Bond Collection",
        "poster_path": "https://image.tmdb.org/t/p/original/HORpg5CSkmeQlAolx3bKMrKgfi.jpg"
    },
    {
        "id": 117693,
        "name": "Balto Collection",
        "poster_path": "https://image.tmdb.org/t/p/original/w0ZgH6Lgxt2bQYnf1ss74UvYftm.jpg"
    },
    {
        "id": 3167,
        "name": "Ace Ventura Collection",
        "poster_path": "https://image.tmdb.org/t/p/original/qCxH543pScFed1CycwJ1nVgrkOc.jpg"
    },
    {
        "id": 91698,
        "name": "Chili Palmer Collection",
        "poster_path": "https://image.tmdb.org/t/p/original/ae3smJDdWrMJ77tDpYOrpo4frKq.jpg"
    },
    {
        "id": 9435,
        "name": "Babe Collection",
        "poster_path": "https://image.tmdb.org/t/p/original/jgnah0k4AumfcZE4HHMJywYHvG6.jpg"
    },
    {
        "id": 9818,
        "name": "Mortal Kombat Collection",
        "poster_path": "https://image.tmdb.org/t/p/original/nauCllomdtyciLCRcVrSJKcJQbn.jpg"
    },
    {
        "id": 136214,
        "name": "Pocahontas Collection",
        "poster_path": "https://image.tmdb.org/t/p/original/s4RkDe4AjwyrlltdF6Ui7INlME6.jpg"
    },
    {
        "id": 124935,
        "name": "The Lawnmower Man Collection",
        "poster_path": "https://image.tmdb.org/t/p/original/slBKrKBbL1g3KURphhAYIyOOH0G.jpg"
    },
    {
        "id": 43563,
        "name": "Friday Collection",
        "poster_path": "https://image.tmdb.org/t/p/original/dWh1Fohgx07AEd4vRUwgIj8BYxD.jpg"
    },
    {
        "id": 10924,
        "name": "From Dusk Till Dawn Collection",
        "poster_path": "https://image.tmdb.org/t/p/original/a156nAy5ZTGXlO5wgfvnF26aaDB.jpg"
    },
    {
        "id": 122017,
        "name": "Screamers Collection",
        "poster_path": "https://image.tmdb.org/t/p/original/vtCuIaQvK3IyLENmuc73RFm4TU7.jpg"
    }
];


// constants images for slider

export const data = [
    {
        belongs_to_collection: {
            id: 131292,
            name: "Iron Man Collection",
            poster_path: "/fbeJ7f0aD4A112Bc1tnpzyn82xO.jpg",
            backdrop_path: "/rI8zOWkRQJdlAyQ6WJOSlYK6JxZ.jpg"
        },
        _id: "654e43c8384f910ce5614b9d",
        adult: false,
        backdrop_path: "/aFTYFqrWp4RS46Twm87l5e0ItYb.jpg",
        genres: [
            {
                id: 28,
                name: "Action",
                _id: "654e43c8384f910ce5614b9e"
            },
            {
                id: 12,
                name: "Adventure",
                _id: "654e43c8384f910ce5614b9f"
            },
            {
                id: 878,
                name: "Science Fiction",
                _id: "654e43c8384f910ce5614ba0"
            }
        ],
        homepage: "https://www.marvel.com/movies/iron-man-3",
        id: 68721,
        imdb_id: "tt1300854",
        original_language: "en",
        original_title: "Iron Man 3",
        overview: "When Tony Stark's world is torn apart by a formidable terrorist called the Mandarin, he starts an odyssey of rebuilding and retribution.",
        popularity: 66.955,
        poster_path: "/qhPtAc1TKbMPqNvcdXSOn9Bn7hZ.jpg",
        production_companies: [
            {
                id: 420,
                logo_path: "/hUzeosd33nzE5MCNsZxCGEKTXaQ.png",
                name: "Marvel Studios",
                origin_country: "US",
                _id: "654e43c8384f910ce5614ba1"
            }
        ],
        release_date: "2013-04-18",
        runtime: 130,
        spoken_languages: [
            {
                english_name: "English",
                iso_639_1: "en",
                name: "English",
                _id: "654e43c8384f910ce5614ba2"
            }
        ],
        status: "Released",
        tagline: "Unleash the power behind the armor.",
        title: "Iron Man 3",
        video: false,
        vote_average: 6.927,
        vote_count: 21135,
        __v: 0
    },
    {
        belongs_to_collection: {
            // id: 131292,
            id: 131292,
            name: "Iron Man Collection",
            poster_path: "/fbeJ7f0aD4A112Bc1tnpzyn82xO.jpg",
            backdrop_path: "/rI8zOWkRQJdlAyQ6WJOSlYK6JxZ.jpg"
        },
        _id: "654e43c8384f910ce5614d06",
        adult: false,
        backdrop_path: "/cyecB7godJ6kNHGONFjUyVN9OX5.jpg",
        genres: [
            {
                id: 28,
                name: "Action",
                _id: "654e43c8384f910ce5614d07"
            },
            {
                id: 878,
                name: "Science Fiction",
                _id: "654e43c8384f910ce5614d08"
            },
            {
                id: 12,
                name: "Adventure",
                _id: "654e43c8384f910ce5614d09"
            }
        ],
        homepage: "https://www.marvel.com/movies/iron-man",
        id: 1726,
        imdb_id: "tt0371746",
        original_language: "en",
        original_title: "Iron Man",
        overview: "After being held captive in an Afghan cave, billionaire engineer Tony Stark creates a unique weaponized suit of armor to fight evil.",
        popularity: 90.358,
        poster_path: "/78lPtwv72eTNqFW9COBYI0dWDJa.jpg",
        production_companies: [
            {
                id: 420,
                logo_path: "/hUzeosd33nzE5MCNsZxCGEKTXaQ.png",
                name: "Marvel Studios",
                origin_country: "US",
                _id: "654e43c8384f910ce5614d0a"
            }
        ],
        release_date: "2008-04-30",
        runtime: 126,
        spoken_languages: [
            {
                english_name: "English",
                iso_639_1: "en",
                name: "English",
                _id: "654e43c8384f910ce5614d0b"
            },
            {
                english_name: "Persian",
                iso_639_1: "fa",
                name: "فارسی",
                _id: "654e43c8384f910ce5614d0c"
            },
            {
                english_name: "Urdu",
                iso_639_1: "ur",
                name: "اردو",
                _id: "654e43c8384f910ce5614d0d"
            },
            {
                english_name: "Arabic",
                iso_639_1: "ar",
                name: "العربية",
                _id: "654e43c8384f910ce5614d0e"
            }
        ],
        status: "Released",
        tagline: "Heroes aren't born. They're built.",
        title: "Iron Man",
        video: false,
        vote_average: 7.639,
        vote_count: 24974,
        __v: 0
    },
    {
        belongs_to_collection: {
            id: 131292,
            name: "Iron Man Collection",
            poster_path: "/fbeJ7f0aD4A112Bc1tnpzyn82xO.jpg",
            backdrop_path: "/rI8zOWkRQJdlAyQ6WJOSlYK6JxZ.jpg"
        },
        _id: "654e43c8384f910ce5614d79",
        adult: false,
        backdrop_path: "/jesRqfL9v6HNnowe795xjmuKUXl.jpg",
        genres: [
            {
                id: 12,
                name: "Adventure",
                _id: "654e43c8384f910ce5614d7a"
            },
            {
                id: 28,
                name: "Action",
                _id: "654e43c8384f910ce5614d7b"
            },
            {
                id: 878,
                name: "Science Fiction",
                _id: "654e43c8384f910ce5614d7c"
            }
        ],
        homepage: "https://www.marvel.com/movies/iron-man-2",
        id: 10138,
        imdb_id: "tt1228705",
        original_language: "en",
        original_title: "Iron Man 2",
        overview: "With the world now aware of his dual life as the armored superhero Iron Man, billionaire inventor Tony Stark faces pressure from the government, the press and the public to share his technology with the military. Unwilling to let go of his invention, Stark, with Pepper Potts and James 'Rhodey' Rhodes at his side, must forge new alliances – and confront powerful enemies.",
        popularity: 92.126,
        poster_path: "/6WBeq4fCfn7AN0o21W9qNcRF2l9.jpg",
        production_companies: [
            {
                id: 420,
                logo_path: "/hUzeosd33nzE5MCNsZxCGEKTXaQ.png",
                name: "Marvel Studios",
                origin_country: "US",
                _id: "654e43c8384f910ce5614d7d"
            },
            {
                id: 7297,
                logo_path: "/l29JYQVZbTcjZXoz4CUYFpKRmM3.png",
                name: "Fairview Entertainment",
                origin_country: "US",
                _id: "654e43c8384f910ce5614d7e"
            }
        ],
        release_date: "2010-04-28",
        runtime: 124,
        spoken_languages: [
            {
                english_name: "English",
                iso_639_1: "en",
                name: "English",
                _id: "654e43c8384f910ce5614d7f"
            },
            {
                english_name: "Russian",
                iso_639_1: "ru",
                name: "Pусский",
                _id: "654e43c8384f910ce5614d80"
            },
            {
                english_name: "French",
                iso_639_1: "fr",
                name: "Français",
                _id: "654e43c8384f910ce5614d81"
            }
        ],
        status: "Released",
        tagline: "It's not the armor that makes the hero, but the man inside.",
        title: "Iron Man 2",
        video: false,
        vote_average: 6.835,
        vote_count: 19832,
        __v: 0
    },
    {
        belongs_to_collection: {
            id: 131292,
            name: "Iron Man Collection",
            poster_path: "/fbeJ7f0aD4A112Bc1tnpzyn82xO.jpg",
            backdrop_path: "/rI8zOWkRQJdlAyQ6WJOSlYK6JxZ.jpg"
        },
        _id: "654e43c9384f910ce5617da3",
        adult: false,
        backdrop_path: "/xzCe37rMKvYUnrAhIxpLJwv7Xmo.jpg",
        genres: [
            {
                id: 12,
                name: "Adventure",
                _id: "654e43c9384f910ce5617da4"
            },
            {
                id: 28,
                name: "Action",
                _id: "654e43c9384f910ce5617da5"
            },
            {
                id: 18,
                name: "Drama",
                _id: "654e43c9384f910ce5617da6"
            }
        ],
        homepage: "",
        id: 9313,
        imdb_id: "tt0120744",
        original_language: "en",
        original_title: "The Man in the Iron Mask",
        overview: "Years have passed since the Three Musketeers, Aramis, Athos and Porthos, have fought together with their friend, D'Artagnan. But with the tyrannical King Louis using his power to wreak havoc in the kingdom while his twin brother, Philippe, remains imprisoned, the Musketeers reunite to abduct Louis and replace him with Philippe.",
        popularity: 25.653,
        poster_path: "/zHE9yRURvA7DyhYtQxkGTfE1Ywi.jpg",
        production_companies: [
            {
                id: 60,
                logo_path: "/1SEj4nyG3JPBSKBbFhtdcHRaIF9.png",
                name: "United Artists",
                origin_country: "US",
                _id: "654e43c9384f910ce5617da7"
            },
            {
                id: 21,
                logo_path: "/5Va1Ie5c4sjfEYqixQ3L8qg7fKu.png",
                name: "Metro-Goldwyn-Mayer",
                origin_country: "US",
                _id: "654e43c9384f910ce5617da8"
            }
        ],
        release_date: "1998-03-12",
        runtime: 132,
        spoken_languages: [
            {
                english_name: "English",
                iso_639_1: "en",
                name: "English",
                _id: "654e43c9384f910ce5617da9"
            },
            {
                english_name: "Italian",
                iso_639_1: "it",
                name: "Italiano",
                _id: "654e43c9384f910ce5617daa"
            }
        ],
        status: "Released",
        tagline: "For the honor of a king. And the destiny of a country. All for one.",
        title: "The Man in the Iron Mask",
        video: false,
        vote_average: 6.623,
        vote_count: 3567,
        __v: 0
    },
    {
        belongs_to_collection: {
            id: 334356,
            name: "The Man with the Iron Fists Collection",
            poster_path: "/3ag7T0qwL3yAMrocJERu4z3eMYW.jpg",
            backdrop_path: "/1gTLyR2zGYhbeJ9rfsJBu8MJQ3o.jpg"
        },
        _id: "654e43cb384f910ce561a6fe",
        adult: false,
        backdrop_path: "/bTeyNpG9PczQbgeQuSndkMuLlna.jpg",
        genres: [
            {
                id: 28,
                name: "Action",
                _id: "654e43cb384f910ce561a6ff"
            }
        ],
        homepage: "",
        id: 97430,
        imdb_id: "tt1258972",
        original_language: "en",
        original_title: "The Man with the Iron Fists",
        overview: "In feudal China, a blacksmith who makes weapons for a small village is put in the position where he must defend himself and his fellow villagers.",
        popularity: 18.597,
        poster_path: "/9dipO9811zpe3P7H26w9X1z1U2y.jpg",
        production_companies: [
            {
                id: 11112,
                logo_path: null,
                name: "Arcade Pictures",
                origin_country: "",
                _id: "654e43cb384f910ce561a700"
            },
            {
                id: 11113,
                logo_path: null,
                name: "Iron Fists",
                origin_country: "",
                _id: "654e43cb384f910ce561a701"
            },
            {
                id: 33,
                logo_path: "/8lvHyhjr8oUKOOy2dKXoALWKdp0.png",
                name: "Universal Pictures",
                origin_country: "US",
                _id: "654e43cb384f910ce561a702"
            }
        ],
        release_date: "2012-11-02",
        runtime: 96,
        spoken_languages: [
            {
                english_name: "English",
                iso_639_1: "en",
                name: "English",
                _id: "654e43cb384f910ce561a703"
            },
            {
                english_name: "Cantonese",
                iso_639_1: "cn",
                name: "广州话 / 廣州話",
                _id: "654e43cb384f910ce561a704"
            },
            {
                english_name: "Mandarin",
                iso_639_1: "zh",
                name: "普通话",
                _id: "654e43cb384f910ce561a705"
            }
        ],
        status: "Released",
        tagline: "You can't spell Kung Fu without F and U!",
        title: "The Man with the Iron Fists",
        video: false,
        vote_average: 5.513,
        vote_count: 1053,
        __v: 0
    }
]
